import React from "react";
import { CheckIcon } from "lucide-react";
import { Accordion } from "./Accordion";
import { BuyButton } from "./BuyButton";
import { MODULES } from "../lib/data";
export function Modules() {
  return <section className="px-4 pt-8" data-id="element-114" data-mp="1vwsm2so45po1">
      <div className="mx-auto max-w-md" data-id="element-115" data-mp="1vxu4xjbdfggb">
        <p className="mb-4 text-center text-sm font-semibold uppercase tracking-wide text-teal-600" data-id="element-116" data-mp="20vvmu0x299q7">
          Todo lo que incluye
        </p>
        <div className="space-y-3" data-id="element-117" data-mp="147h097p5sltv">
          {MODULES.map((m, idx) => <Accordion key={m.title} emoji={m.emoji} title={m.title} badge={m.count} defaultOpen={idx === 0} data-id="element-118" data-mp="188j27wagnbzj" data-mpi={idx}>
              <ul className="space-y-2.5" data-id="element-119" data-mp="1i5xhhsknduq9">
                {m.items.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-120" data-mp="2om98n9p1yccc" data-mpi={i}>
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-600" data-id="element-121" data-mp="2oo3s0jkodweb" />
                    <span className="text-[13.5px] leading-snug text-slate-600" data-id="element-122" data-mp="2tmx9en3327jr">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </Accordion>)}
        </div>

        <div className="mt-6" data-id="element-123" data-mp="3oz9ayzmrkwgu">
          <BuyButton data-id="element-124" data-mp="3oyhj9zwafivu" />
        </div>
      </div>
    </section>;
}